import { OverlayContent } from '../../../enums/elementId';
import { State } from '../index';
import { isObjectDeeplyChanged } from '../../../util/state';

export const getUpdateFlags = (state: State, oldState: State) => {
    const { responseData, openedBy, activeOverlay, isOverlayOpen, formData } = state;
    const overlayChanged = oldState.activeOverlay !== activeOverlay;
    const overlayOpened = isOverlayOpen && oldState.isOverlayOpen !== isOverlayOpen;
    const isLmsOpened = (overlayChanged || overlayOpened) && activeOverlay === OverlayContent.LMS_MODULE;
    const isFormChanged = isObjectDeeplyChanged(oldState.formData, formData) || isLmsOpened;

    return {
        opener: oldState.openedBy !== openedBy,
        lmsResult: responseData !== oldState.responseData,
        isLmsOpened,
        isFormChanged,
    };
};
